import React from 'react';
import '../App.css'

function Footer() {
    return ( 
        <div className='footer'>
            <p>Books App 2022&copy;</p>
        </div>
    );
}

export default Footer;